export const NAME = 'toast'
